import React, { memo, useState, useContext, useEffect, useRef } from "react";

import { Box, Button, Divider } from "@mui/material";

import Tabla from "./Componentes/Tabla";
import Modal from "./Componentes/Modal";

import BarraTablas from "../../../../components/BarraTablas/BarraTablas";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../../Context/Auth/AuthContext";
import clienteAxios from "../../../../config/axios";

import io from "socket.io-client";
import { socketUrl } from "../../../../config/const";
import ModalB from "../../../components/Modal/ModalB";
const Proveedores = (props) => {
  // const { llamadoDeOtroLugar, setopenMT } = props;
  const {
    desdeOtroLugarMenu,
    rolesSeleccionados,
    setpersonasSeleccionadas,
    // puedeExportar,
    // itemRelacionadoPadre,
  } = props;
  // DATA DEL STATE

  // DATA DEL STATE
  const [rows, setrows] = useState(null);
  const [columns, setcolumns] = useState([]);
  const [cumple, setcumple] = useState(false);
  const columns2 = [
    {
      id: "perNombreContrato",
      label: "Nombre Contrato",
      minWidth: 50,
      tipo: "string",
      propiedad: "perNombreContrato",
    },
    {
      id: "perEstadoContrado",
      label: "Estado Contrado",
      minWidth: 50,
      tipo: "string",
      propiedad: "perEstadoContrado",
    },
    {
      id: "perUbicacionContrato",
      label: "Ciudad",
      minWidth: 50,
      tipo: "string",
      propiedad: "perUbicacionContrato",
    },
    {
      id: "perSector",
      label: "Sector",
      minWidth: 50,
      tipo: "string",
      propiedad: "perSector",
    },
    {
      id: "perFecContrato",
      label: "Fec. Contrato",
      minWidth: 50,
      tipo: "string",
      propiedad: "perFecContrato",
    },
    {
      id: "perFecInstalacion",
      label: "Fec. Instalación",
      minWidth: 5.0,
      tipo: "string",
      propiedad: "perFecInstalacion",
    },
    {
      id: "perDiaCobro",
      label: "Día Cobro",
      minWidth: 50,
      tipo: "string",
      propiedad: "perDiaCobro",
    },
    {
      id: "perTipoPlan",
      label: "Tipo Plan",
      minWidth: 50,
      tipo: "string",
      propiedad: "perTipoPlan",
    },
    {
      id: "perNombrePlan",
      label: "Nombre Plan",
      minWidth: 50,
      tipo: "string",
      propiedad: "perNombrePlan",
    },
    {
      id: "perValorPlan",
      label: "Valor Plan",
      minWidth: 50,
      tipo: "string",
      propiedad: "perValorPlan",
    },
    {
      id: "perMegas",
      label: "Megas",
      minWidth: 50,
      tipo: "string",
      propiedad: "perMegas",
    },
    {
      id: "PPPOEoIP",
      label: "OEoIP",
      minWidth: 50,
      tipo: "string",
      propiedad: "PPPOEoIP",
    },
    {
      id: "perVendedor1",
      label: "Vendedor 1",
      minWidth: 50,
      tipo: "string",
      propiedad: "perVendedor1",
    },
    {
      id: "perTecnico1",
      label: "Tecnico 1",
      minWidth: 50,
      tipo: "string",
      propiedad: "perTecnico1",
    },
  ];
  const [ObjectoActivo, setObjetoActivo] = useState({
    perISPContratos: [],
    perNombreComercial: "",
    perEmpresa: [],
    perPais: "",
    perProvincia: "",
    perCanton: "",
    perTipoProveedor: "BIENES",
    perTiempoCredito: "0",
    perDocTipo: "",
    perDocNumero: "",
    perPerfil: [],
    perNombre: "",
    perDireccion: "",
    perObligado: "NO",
    perCredito: "NO",
    perTelefono: "0",
    perCelular: ["+593"],
    perEstado: "ACTIVO",
    perObsevacion: "",
    perEmail: ["sin@sincorreo.com"],
    perOtros: ["ZZZ9999"],
    perNickname: "",
    perUser: "",
    perFecReg: "",
    perFoto: "",
    perUbicacion: {
      longitud: "",
      latitud: "",
    },
    perDocumento: "",
    perGenero: "M",
    perRecomendacion: "OTROS",
    perFecNacimiento: "",
    perEspecialidad: "",
    perTitulo: "",
    perSenescyt: "",
    perPersonal: "INTERNO",
    validateEmail: 1,
  });
  const [pagination, setpagination] = useState(null);
  // FUNCIONES STATE
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    datos2,
    rucempresa,
    perfil,
    cumple
  ) => {
    const res = await clienteAxios.get(
      `/proveedores/byPagination/isp?cantidad=${cantidad}&page=${page}&search=${
        search ? search : ""
      }&input=${input ? input : ""}&orden=${orden ? orden : ""}&datos=${
        datos ? datos : ""
      }&datosContratos=${datos2}&rucempresa=${
        rucempresa ? rucempresa : ""
      }&perfil=${
        perfil ? perfil : ""
      }&fromPermisos=${desdeOtroLugarMenu}&cumple=${cumple}`
    );
    console.log({ res });
    return res;
  };

  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    datos2,
    rucempresa,
    estado,
    cumple
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      datos2,
      rucempresa,
      estado,
      cumple
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    datos2,
    rucempresa,
    estado,
    cumple
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      datos2,
      rucempresa,
      estado,
      cumple
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
    // dispatch({
    //   type: OBTENER,
    //   payload: {
    //     results: res.data.data.results,
    //     pagination: res.data.data.pagination,
    //   },
    // });
  };
  const agregarState = async (item, funcionAalerta) => {
    try {
      setrows([item, ...rows]);

      setpagination({
        ...pagination,
        numRows: pagination.numRows + 1,
      });
      funcionAalerta();
    } catch (error) {}
  };

  const editarState = async (item, funcionAalerta) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR.perId === item.perId) {
          return item;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
      funcionAalerta();
    } catch (error) {}
  };

  const eliminarState = async (_id, funcionAalerta) => {
    try {
      const resRows = rows.filter((row) => {
        return row.perId !== _id;
      });
      setrows(resRows);
      setpagination({
        ...pagination,
        numRows: pagination.numRows - 1,
      });
      funcionAalerta();
    } catch (error) {}
  };
  const eliminarSeleccionState = async (_ids, funcionAalerta) => {
    const resRows = rows.filter((row) => {
      return !_ids.some((item) => {
        return item === row.perId;
      });
    });
    setpagination({
      ...pagination,
      numRows: pagination.numRows - _ids.length,
    });
    setrows(resRows);
    funcionAalerta();
  };

  const changeObjetoActivoState = (item) => {
    setObjetoActivo(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };

  const rowsImportState = (rows) => {
    // dispatch({
    //   type: IMPORTAR_ROWS,
    //   payload: rows,
    // });
    setrows(rows);
  };
  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // FUNCIONES SOCKET
  const [tabla] = useState("proveedor");
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });
  const socket = useRef();
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error"
      );
    });
    return () => {
      socket.current.disconnect();
    };
    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }

    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    if (tipo === "agregar") {
      agregarState(item);
    }
    if (tipo === "editar") {
      editarState(item);
    }
    if (tipo === "eliminar") {
      eliminarState(item.perId);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);
  // FIN FUNCIONES SOCKET
  const [arrayExport, setarrayExport] = useState([]);
  useEffect(() => {
    if (!desdeOtroLugarMenu) {
      return;
    }

    setpersonasSeleccionadas(arrayExport);
    //eslint-disable-next-line
  }, [arrayExport]);
  const [campoExport] = useState("perId");
  const [estadoRequest, setestadoRequest] = useState("CLIENTE");
  const defaultFullBuscador = () => {
    const json = {};
    columns.forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else if (itemPropiedad.tipo === "numero") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        } else if (itemPropiedad.tipo === "fecha") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });
    return json;
  };
  const defaultFullBuscador2 = () => {
    const json = {};
    columns2.forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else if (itemPropiedad.tipo === "numero") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        } else if (itemPropiedad.tipo === "fecha") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });
    return json;
  };
  useEffect(() => {
    const rescolumns = desdeOtroLugarMenu
      ? [
          {
            id: "perDocNumero",
            label: "Documento",
            minWidth: 50,
            tipo: "string",
            propiedad: "perDocNumero",
          },
          {
            id: "perNombre",
            label: "Nombres",
            minWidth: 50,
            tipo: "string",
            propiedad: "perNombre",
          },
          {
            id: "perPermisos",
            label: "Permisos Personalizados",
            minWidth: 250,
            tipo: "",
            propiedad: "perPermisos",
          },
          {
            id: "perPerfil",
            label: "Roles",
            minWidth: 50,
            tipo: "",
            propiedad: "perPerfil",
          },

          {
            id: "perUser",
            label: "User",
            minWidth: 50,
            tipo: "string",
            propiedad: "perUser",
          },
          {
            id: "perFecUpd",
            label: "Fec Upd",
            minWidth: 50,
            tipo: "string",
            propiedad: "perFecUpd",
          },
        ]
      : estadoRequest === ""
      ? [
          {
            id: "perDocTipo",
            label: "Tipo Doc",
            minWidth: 50,
            tipo: "string",

            propiedad: "perDocTipo",
          },
          {
            id: "perDocNumero",
            label: "Documento",
            minWidth: 50,
            tipo: "string",

            propiedad: "perDocNumero",
          },
          {
            id: "perNombre",
            label: "Nombres",
            minWidth: 50,
            tipo: "string",

            propiedad: "perNombre",
          },
          {
            id: "validateEmail",
            label: "Email Val.",
            minWidth: 50,
            tipo: "string",

            propiedad: "validateEmail",
          },
          {
            id: "ciudad",
            label: "Monitoreo",
            minWidth: 200,
            tipo: "string",

            propiedad: "ciudad",
          },
          {
            id: "perMovil",
            label: "Celular",
            minWidth: 50,
            tipo: "string",

            propiedad: "perMovil",
          },

          {
            id: "perEmail",
            label: "Email",
            minWidth: 50,
            tipo: "string",

            propiedad: "perEmail",
          },
          {
            id: "perUser",
            label: "User",
            minWidth: 50,
            tipo: "string",

            propiedad: "perUser",
          },
          {
            id: "perFecUpd",
            label: "Fec Upd",
            minWidth: 50,
            tipo: "string",
            propiedad: "perFecUpd",
          },
        ]
      : [
          {
            id: "perDocTipo",
            label: "Tipo Doc",
            minWidth: 50,
            tipo: "string",

            propiedad: "perDocTipo",
          },
          {
            id: "perDocNumero",
            label: "Documento",
            minWidth: 50,
            tipo: "string",

            propiedad: "perDocNumero",
          },
          {
            id: "perNombre",
            label: "Nombres",
            minWidth: 50,
            tipo: "string",

            propiedad: "perNombre",
          },
          {
            id: "perISPContratos",
            label: "TOTAL",
            minWidth: 50,
            tipo: "string",
            ocultar: true,
            propiedad: "perISPContratos",
          },
          {
            id: "perISPContratos",
            label: "Contratos",
            minWidth: 200,
            tipo: "string",
            ocultar: true,
            propiedad: "perISPContratos",
          },
          {
            id: "perISPContratos",
            label: "Equipo",
            minWidth: 200,
            tipo: "string",
            ocultar: true,
            propiedad: "perISPContratos",
          },
          {
            id: "ciudad",
            label: "Monitoreo",
            minWidth: 200,
            tipo: "string",

            propiedad: "ciudad",
          },
          {
            id: "perMovil",
            label: "Celular",
            minWidth: 50,
            tipo: "string",

            propiedad: "perMovil",
          },

          // {
          //   id: "perEmail",
          //   label: "Email",
          //   minWidth: 50,
          //   tipo: "string",

          //   propiedad: "perEmail",
          // },
          {
            id: "perUser",
            label: "User",
            minWidth: 50,
            tipo: "string",

            propiedad: "perUser",
          },
          {
            id: "perFecUpd",
            label: "Fec Upd",
            minWidth: 50,
            tipo: "string",
            propiedad: "perFecUpd",
          },
        ];
    setcolumns(rescolumns);
  }, [estadoRequest]);
  const [open, setopen] = useState(false);
  const [buscando, setbuscando] = useState(false);
  const [editar, seteditar] = useState(false);
  const [search, setsearch] = useState("");
  const [cargando, setcargando] = useState(false);
  const [input, setinput] = useState({
    id: "perFecUpd",
    label: "ID",
    minWidth: 150,
    tipo: "string",

    propiedad: "perFecUpd",
  });

  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    usuario: { rucempresa, empRoles },
    usuario,
  } = useContext(AuthContext);
  const [orden, setorden] = useState(false);
  const [openMB, setopenMB] = useState(false);
  const [fullBuscador, setfullBuscador] = useState({});
  const [fullBuscador2, setfullBuscador2] = useState({});
  //pagina actual
  const [page, setPage] = React.useState(0);
  //filas por pagina
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // input
  //
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  const handleChange2 = (e) => {
    setfullBuscador2({ ...fullBuscador2, [e.target.name]: e.target.value });
  };
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      JSON.stringify(fullBuscador2),
      rucempresa,
      estadoRequest,
      cumple
    );
    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };

  const handleSearch = async () => {
    setarrayExport([]);
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      JSON.stringify(fullBuscador2),
      rucempresa,
      estadoRequest,
      cumple
    );

    setPage(0);
    setcargando(false);
  };
  const funcionDefault = async () => {
    setcargando(true);
    setfullBuscador(defaultFullBuscador());
    setfullBuscador2(defaultFullBuscador2());
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      orden,
      JSON.stringify(defaultFullBuscador()),
      JSON.stringify(defaultFullBuscador2()),
      rucempresa,
      estadoRequest,
      cumple
    );

    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };
  const funcArchivo = async (e) => {
    if (!e.target.files[0]) {
      return;
    } else {
      if (e.target.files[0].type !== "text/plain") {
        return mostrarAlerta("El archivo no es de texto");
      } else {
        const formDataLogos = new FormData();
        formDataLogos.append("archivo", e.target.files[0]);
        formDataLogos.append("tipo", "compras");
        const res = await clienteAxios.post(
          "/uploads_comprastxt",
          formDataLogos
        );
        rowsImportState({ res });
      }
    }
  };

  return (
    <Box>
      <BarraTablas
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        setopen={setopen}
        open={open}
        openMB={openMB}
        setopenMB={setopenMB}
        LabelBuscador="Buscar por todos los campos"
        funcionDefault={funcionDefault}
        subirArchivo={false}
        funcArchivo={funcArchivo}
        ocultarBuscar={false}
        ocultarMigasDePan={desdeOtroLugarMenu}
        ocultarAgregar={desdeOtroLugarMenu}
        ocultarOpciones={desdeOtroLugarMenu}
      />
      <Box display={"flex"} justifyContent={"center"}>
        <ModalB
          defaultFullBuscador={defaultFullBuscador}
          openMB={openMB}
          setopenMB={setopenMB}
          titulo={"Busqueda avanzada (Personas)"}
          fullBuscador={fullBuscador}
          setfullBuscador={setfullBuscador}
          arrayProps={columns}
          handleChange={handleChange}
          funcionB={funcionB}
          buscando={buscando}
          funcionDefault={funcionDefault}
          estadoRequest={estadoRequest}
        />
        <ModalB
          defaultFullBuscador={defaultFullBuscador2}
          openMB={openMB}
          setopenMB={setopenMB}
          titulo={"Busqueda avanzada (Contratos)"}
          fullBuscador={fullBuscador2}
          setfullBuscador={setfullBuscador2}
          arrayProps={columns2}
          handleChange={handleChange2}
          funcionB={funcionB}
          buscando={buscando}
          funcionDefault={funcionDefault}
          estadoRequest={estadoRequest}
        />
      </Box>
      {desdeOtroLugarMenu ? null : (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems=" stretch"
          width="100%"
        >
          <Box>
            {empRoles.slice(2).map((itemRol, index) => {
              return (
                <Button
                  size="small"
                  key={index}
                  variant={estadoRequest === itemRol ? "contained" : null}
                  onClick={async () => {
                    setcargando(true);
                    await remplazarRowsState(
                      rowsPerPage,
                      0,
                      "",
                      input.id,
                      orden,
                      JSON.stringify(fullBuscador),
                      JSON.stringify(fullBuscador2),
                      rucempresa,
                      itemRol,
                      cumple
                    ); 
                    setPage(0);
                    setestadoRequest(itemRol);
                    setcargando(false);
                  }}
                  disableElevation
                  style={{
                    padding: ".5rem",
                    borderRadius: "15px 15px  0px 0px",
                  }}
                  color="primary"
                >
                  {itemRol}
                </Button>
              );
            })}
          </Box>
          <Box>
            <Button
              size="small"
              variant={cumple ? "contained" : null}
              onClick={async () => {
                setcargando(true);
                await remplazarRowsState(
                  rowsPerPage,
                  0,
                  "",
                  input.id,
                  orden,
                  JSON.stringify(fullBuscador),
                  JSON.stringify(fullBuscador2),
                  rucempresa,
                  estadoRequest,
                  !cumple
                ); 
                setcumple(!cumple);
                setPage(0);
                setcargando(false);
              }}
              disableElevation
              style={{
                padding: ".5rem",
                borderRadius: "15px 15px  0px 0px",
              }}
              color="success"
            >
              CUMPLEAÑOS
            </Button>
            <Button
              size="small"
              variant={estadoRequest === "" && !cumple ? "contained" : null}
              onClick={async () => {
                setcargando(true);
                await remplazarRowsState(
                  rowsPerPage,
                  0,
                  "",
                  input.id,
                  orden,
                  JSON.stringify(fullBuscador),
                  JSON.stringify(fullBuscador2),
                  rucempresa,
                  "",
                  false
                );
                setcumple(false);
                setPage(0);
                setestadoRequest("");
                setcargando(false);
              }}
              disableElevation
              style={{
                padding: ".5rem",
                borderRadius: "15px 15px  0px 0px",
              }}
              color="secondary"
            >
              NO CLIENTE
            </Button>
          </Box>
        </Box>
      )}
      <Divider />
      <Tabla
        estadoRequest={estadoRequest}
        cumple={cumple}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        search={search}
        input={input}
        orden={orden}
        setinput={setinput}
        setorden={setorden}
        seteditar={seteditar}
        setopen={setopen}
        buscando={buscando}
        cargando={cargando}
        setcargando={setcargando}
        fullBuscador={fullBuscador}
        fullBuscador2={fullBuscador2}
        //  STATE
        rows={rows}
        columns={columns}
        ObjectoActivo={ObjectoActivo}
        pagination={pagination}
        // FUNCIONES STATE
        getDataState={getDataState}
        obtenerState={obtenerState}
        addRowsState={addRowsState}
        remplazarRowsState={remplazarRowsState}
        agregarState={agregarState}
        editarState={editarState}
        eliminarState={eliminarState}
        eliminarSeleccionState={eliminarSeleccionState}
        changeObjetoActivoState={changeObjetoActivoState}
        rowsImportState={rowsImportState}
        arrayExport={arrayExport}
        campoExport={campoExport}
        setarrayExport={setarrayExport}
        socket={socket}
        desdeOtroLugarMenu={desdeOtroLugarMenu}
        rolesSeleccionados={rolesSeleccionados}
      />
      <Modal
        estadoRequest={estadoRequest}
        editar={editar}
        seteditar={seteditar}
        setopen={setopen}
        open={open}
        ObjectoActivo={ObjectoActivo}
        changeObjetoActivoState={changeObjetoActivoState}
        socket={socket}
      />
    </Box>
  );
};

export default memo(Proveedores);
